
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getpassword",
      function () {
        return require("private-next-pages/getpassword.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getpassword"])
      });
    }
  